import { render, staticRenderFns } from "./SatelliteLandings.vue?vue&type=template&id=4c8cd489&scoped=true"
import script from "./SatelliteLandings.vue?vue&type=script&lang=js"
export * from "./SatelliteLandings.vue?vue&type=script&lang=js"
import style0 from "./SatelliteLandings.vue?vue&type=style&index=0&id=4c8cd489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cd489",
  null
  
)

export default component.exports